import React, { useState, useEffect, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "app/components/Grid/GridItem.js";
import GridContainer from "app/components/Grid/GridContainer.js";
import Card from "app/components/Card/Card.js";
import CardHeader from "app/components/Card/CardHeader.js";
import CardBody from "app/components/Card/CardBody.js";
import axios from 'axios';
import { useLocation } from 'react-router';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';
import SeaBookingSummary from "app/components/Summary/SeaBookingSummary.js";
import AirBookingSummary from "app/components/Summary/AirBookingSummary.js";
import { LoginStatusContext } from 'app/context/LoginStatusContext';
import { OnClickPopoverCell } from 'app/components/DataGrid/OnClickPopoverCell';
import Iframe from "app/components/IFrame/Iframe";
import { CargoMode } from "app/types/enums";
import LoadingSpinner from '../Dashboard/LoadingSpinner';

const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0",
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
    },
};

const useStyles = makeStyles(styles);

//Format date string
export function ProcessDate(date) {
    const isMinDate = isDateMinValue(date);
    if (date && !isMinDate) {
        var shortDate = date.substring(0, date.indexOf('T'));
        var [YYYY, MM, DD] = shortDate.split('-');
        var formattedShortDate = new Date(YYYY, MM - 1, DD);
        var requiredGBDate = formattedShortDate.toLocaleDateString('en-GB');
        return requiredGBDate;
    }
    return null;
}

function isDateMinValue(date) {
    const dateToCheck = new Date(date);
    return dateToCheck.getUTCFullYear() === 1;

}

export default function ShipmentEdit() {
    const classes = useStyles();

    const { setIsLoggedIn } = useContext(LoginStatusContext);
    const [groupedDocuments, setGroupedDocuments] = useState({});
    const [shipmentDetails, setShipmentDetails] = useState(undefined);
    const [shipmentDetailsLoading, setShipmentDetailsLoading] = useState(true);

    const location = useLocation();
    const params = new URLSearchParams(location.search);

    useEffect(() => {
        async function validateUserSessionId() {
            try {
                await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/login/ValidateUserSessionId`)
                    .then(() => setIsLoggedIn(true));

            } catch (error) {
                setIsLoggedIn(false);
                window.location.replace(`${process.env.PUBLIC_URL}/login`);
            }
        }
        validateUserSessionId();
    }, [setIsLoggedIn]);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/shipment/GetShipmentDetailsById`, { params: { shipmentID: params.get("shipmentId")} })
            .then((res) => {
                console.log(res.data);
                setShipmentDetails(res.data);
                setGroupedDocuments(groupDocumentsByType(res.data.attachments))
                setShipmentDetailsLoading(false);
            })
            .catch(error => console.error(`An error occured whilst getting shipment details. Error: ${error.message}`))
    }, [params]);

    const documentOnClick = (document) => {
        if (document !== null) {
            if (document.stream) {
                openDocument(document);
            }
            else {
                axios
                    .get(`${process.env.REACT_APP_API_ENDPOINT}/api/attachment/GetAttachmentStream`, { params: { fileName: document.filename, location: document.location, attachmentContentId: document.attachmentContentId } })
                    .then((res) => {
                        if (res.data.length !== 0) {
                            document.stream = res.data;
                            openDocument(document);
                        }
                    })
                    .catch((e) => {
                        console.log('Attachment API error happened');
                    });
            }
        }
    }

    function openDocument(document) {
        const binaryString = window.atob(document.stream);
        const bytes = new Uint8Array(binaryString.length);
        const mappedData = bytes.map((byte, i) => binaryString.charCodeAt(i));
        const blob = new Blob([mappedData], { type: document.mediaType });
        const fileUrl = URL.createObjectURL(blob);
        window.open(fileUrl);
    }

    const concaternateContainerDocument = (bookingAttachment) => {
        return (
            <div>
                {`${bookingAttachment.documentTypeDescription} `}
                <a onClick={() => documentOnClick(bookingAttachment)}>
                    <LaunchRoundedIcon style={{ cursor: 'pointer' }}></LaunchRoundedIcon>
                </a>
            </div>
        )
    }

    const concaternateDocumentType = (bookingAttachment, documentCount) => {
        return (
            <div>
                {documentCount > 1 && `${bookingAttachment.documentTypeDescription} ${bookingAttachment.documentReference || ''} `}
                <a onClick={() => documentOnClick(bookingAttachment)}>
                    <LaunchRoundedIcon style={{ cursor: 'pointer' }}></LaunchRoundedIcon>
                </a>
            </div>
        )
    }

    function groupDocumentsByType(documents){
        var groupedDocuments = documents.reduce((result, bookingAttachment) => {
            if (!result[bookingAttachment.documentTypeID]) {
                result[bookingAttachment.documentTypeID] = [];
            }
            result[bookingAttachment.documentTypeID].push(bookingAttachment);
            result[bookingAttachment.documentTypeID].sort((a, b) => new Date(b.dateAdded) - new Date(a.dateAdded));
            return result;
        }, {});

        return groupedDocuments;
    };

    const getDefaultStackMultiplier = (stackMultiplier) => {
        if (stackMultiplier === 2) {
            return "Yes";
        }

        return "No";
    };

    if (shipmentDetailsLoading) {
        return <LoadingSpinner />
    }
    return (
        <div style={{ position: 'relative', zIndex: '0' }}>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Box sx={{ p: 2, display: 'flex' }}>
                        <Card>
                            <CardHeader style={{ backgroundColor: '#1DB35A' }}>
                                <h4 className={classes.cardTitleWhite}>Booking Details Summary</h4>
                            </CardHeader>
                            <CardBody>

                                { shipmentDetails.summary.bookingTypeID === 17 && (<AirBookingSummary bookingDetails={shipmentDetails.summary} > </AirBookingSummary>) }
                                { shipmentDetails.summary.bookingTypeID === 18 && (<SeaBookingSummary bookingDetails={shipmentDetails.summary} trackingEvents={shipmentDetails.milestones}> </SeaBookingSummary> ) }
                                <Accordion style={{ marginTop: "40px" }} defaultExpanded={false}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" style={{ backgroundColor: "#1DB35A", color: "#fff" }}>
                                        <Typography>Map</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        {shipmentDetails.summary.bookingTypeID === 18 && (<Iframe src={shipmentDetails.summary.trackingData} width="100%" height="600px" />)}
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion style={{ marginTop: "40px" }} defaultExpanded={true}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" style={{ backgroundColor: "#1DB35A", color: "#fff" }}>
                                        <Typography>Booking Packages</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <table className='table table-striped' id="ShipmentSearch" aria-labelledby="tabelLabel">
                                            <thead>
                                                <tr>
                                                    <th>Quantity</th>
                                                    <th>Type</th>
                                                    <th>Description</th>
                                                    <th>Total Gross Weight</th>
                                                    <th>Length</th>
                                                    <th>Width</th>
                                                    <th>Height</th>
                                                    <th>Volume</th>
                                                    <th>Stackable</th>
                                                    <th>Container</th>
                                                    {shipmentDetails.summary.cargoMode === CargoMode.FCL && (<th>Delivery Date</th>)}
                                                    <th>Document</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {shipmentDetails.packages.map((item, i) =>
                                                    <tr key={`${item.packageId} - ${i}`}>
                                                        <td>{item.packageCount}</td>
                                                        <td>{item.packageTypeDescription}</td>
                                                        <td>{item.description}</td>
                                                        <td>{item.grossweight}{"\n"}{item.measureUnitsGrossWeight}</td>
                                                        <td>{item.length}{"\n"}{item.measureUnitsLength}</td>
                                                        <td>{item.width}{"\n"}{item.measureUnitsWidth}</td>
                                                        <td>{item.height}{"\n"}{item.measureUnitsHeight}</td>
                                                        <td>{item.volume}{"\n"}{item.measureUnitsVolume}</td>
                                                        <td>{getDefaultStackMultiplier(item.stackMultiplier)}</td>
                                                        <td>{item.container}</td>
                                                        {shipmentDetails.cargoMode === CargoMode.FCL && (<td> {item.estimatedDeliveryAddress && ProcessDate(item.estimatedDeliveryAddress)} </td>)}
                                                        <td>
                                                            <OnClickPopoverCell data={shipmentDetails.attachments.filter((attachment) => {
                                                                return attachment.documentReference === item.container;
                                                            }).map(ba => {
                                                                return concaternateContainerDocument(ba);
                                                            })}
                                                            />
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion style={{ marginTop: "40px" }} defaultExpanded={true}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" style={{ backgroundColor: "#1DB35A", color: "#fff" }}>
                                        <Typography>Documents</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <table className='table table-striped' id="ShipmentSearch" aria-labelledby="tabelLabel">
                                            <thead >
                                                <tr>
                                                    <th>Document Type</th>
                                                    <th>Date Added</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Object.keys(groupedDocuments).map(key =>
                                                    <tr key={groupedDocuments[key][0].attachmentID}>
                                                        <td>{groupedDocuments[key][0].documentTypeDescription}</td>
                                                        <td>{new Date(groupedDocuments[key][0].dateAdded).toLocaleString()}</td>
                                                        <td>
                                                            <OnClickPopoverCell data={groupedDocuments[key].map(gd => {
                                                                return concaternateDocumentType(gd, groupedDocuments[key].length);
                                                            })}
                                                            />
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </AccordionDetails>
                                </Accordion>
                            </CardBody>
                        </Card>
                    </Box>
                </GridItem>
            </GridContainer>
        </div>
    );
}